import React from 'react'

const LoaderButton = () => {
    return (
        <button className="bg-[#fcd7d7] flex justify-center items-center rounded-lg p-1 w-full font-normal md: px-16 shadow-slate-300 shadow-md md:text-[23px] text-[16px]">
            <div className="loader-button"></div>
        </button>
    )
}

export default LoaderButton
